/**
 * Filter counts (task 1093): four counts over the review document. Clicking a
 * count filters the section it describes; clicking the active one clears the
 * filter. Local state only — the URL does not change.
 */

export type ReviewFilter = 'all' | 'attention' | 'differs' | 'newer';

interface ReviewFilterBarProps {
  counts: Record<ReviewFilter, number>;
  active: ReviewFilter;
  onChange: (filter: ReviewFilter) => void;
}

const ITEMS: { id: ReviewFilter; label: string }[] = [
  { id: 'all', label: 'Models in catalog' },
  { id: 'attention', label: 'Deprecated or unknown' },
  { id: 'differs', label: 'Values differ' },
  { id: 'newer', label: 'Newer models available' },
];

export function ReviewFilterBar({ counts, active, onChange }: ReviewFilterBarProps) {
  return (
    <div role="group" aria-label="Review filters" className="grid grid-cols-2 gap-2 sm:grid-cols-4">
      {ITEMS.map(({ id, label }) => {
        const selected = active === id;
        return (
          <button
            key={id}
            type="button"
            aria-pressed={selected}
            data-testid={`review-filter-${id}`}
            onClick={() => onChange(selected && id !== 'all' ? 'all' : id)}
            className={`rounded-lg border px-3 py-2 text-left focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500 ${
              selected
                ? 'border-indigo-500 bg-indigo-50 dark:border-indigo-400 dark:bg-indigo-950/40'
                : 'border-gray-200 bg-white hover:bg-gray-50 dark:border-gray-700 dark:bg-gray-800 dark:hover:bg-gray-700'
            }`}
          >
            <span className="block text-xl font-semibold text-gray-900 dark:text-white">{counts[id]}</span>
            <span className="block text-xs text-gray-600 dark:text-gray-300">{label}</span>
          </button>
        );
      })}
    </div>
  );
}
